import { Checkbox, Colors, Icon } from '@blueprintjs/core'
import * as React from 'react'
import { CategoryRowIconStyle, CategoryRowStyle, CategoryRowStyleHighlighted, TerminalCategoryRowStyle } from './styles'
import { CategoryMultiselectCategory } from './types'
import { targetHasClass } from './utils'

export interface CategoryRowProps {
  category: CategoryMultiselectCategory
  checked: boolean
  highlighted: boolean
  hasChildren?: boolean

  onHighlight?: (highlightedPath: number[]) => void
  onCheck: (category: CategoryMultiselectCategory) => void
}

export class CategoryRow extends React.Component<CategoryRowProps, {}> {
  onCheck = (e: React.FormEvent) => {
    const { onCheck, category } = this.props
    e.stopPropagation()
    onCheck(category)
  }

  onHighlight = (e: React.MouseEvent) => {
    if (targetHasClass(e, 'category-multiselect-row')) {
      const { category, onHighlight } = this.props
      const ancestry = category.ancestry ? category.ancestry.split('/').map(id => parseInt(id)) : []
      if (onHighlight) onHighlight([...ancestry, category.id])
    }
  }

  render() {
    const { category, checked, hasChildren, highlighted } = this.props
    let style = highlighted ? CategoryRowStyleHighlighted : CategoryRowStyle
    if (!hasChildren) style = TerminalCategoryRowStyle

    return (
      <label className="category-multiselect-row" style={style} onClick={hasChildren ? this.onHighlight : undefined}>
        <Checkbox
          onChange={this.onCheck}
          checked={checked}
          style={{ margin: 0 }}
          tabIndex={-1}
          onClick={e => e.stopPropagation()} // Prevent double toggle
        />
        <span style={{ cursor: 'pointer', userSelect: 'none', marginLeft: 4 }}>{category.name}</span>
        {hasChildren && (
          <div style={CategoryRowIconStyle}>
            <Icon icon="chevron-right" color={Colors.GRAY3} />
          </div>
        )}
      </label>
    )
  }
}

export default CategoryRow
